<template>
    <console-layout width="100%" max-width="1280">

        <console-title>
            <span>포인트 내역</span>
        </console-title>

        <console-search @search="page=1; search()">
            <v-row align="center">
                <v-col cols="12" sm="6">
                    <v-date-field v-model="filter.createdAt[0]" label="검색일자" persistent-placeholder hide-details></v-date-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-date-field v-model="filter.createdAt[1]" label="검색일자" persistent-placeholder hide-details></v-date-field>
                </v-col>
            </v-row>
            <v-row class="mt-4">
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                </v-col>
            </v-row>
        </console-search>

        <console-body>
            
            <v-layout class="align-end">
                <span class="subtitle-2">검색수 : {{ summary.totalCount.format() }}</span>
                <v-spacer />
                <span>
                    <v-btn color="white" elevation="1" class="green--text px-2 ml-1" @click="excel">
                        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>엑셀다운로드
                    </v-btn>
                </span>
            </v-layout>
    
            <v-data-table :items="points" :headers="pointsHeaders" hide-default-footer disable-sort disable-pagination class="mt-2 elevation-1">
                <template slot="item.amount" slot-scope="{item}">{{ item.amount.format() }}</template>
                <template slot="item.member.name" slot-scope="{item}">{{ item.member?.name || "탈퇴회원" }}</template>
                <template slot="item.member.username" slot-scope="{item}">{{ item.member?.username || "-" }}</template>
                <template slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="my-4" @input="search(true)"/>

        </console-body>

    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent,
        VDateField
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                createdAt: [this.$route.query.createdAt?.[0] || '', this.$route.query.createdAt?.[1] || ''],
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },
            points: [],
            pointsHeaders: [
                { text: "회원 이름", value: "member.name", align: "center", /* width: 10 */ },
                { text: "회원 아이디", value: "member.username", align: "center" /* width: 10 */ },
                { text: "포인트 금액", value: "amount", align: "center", /* width: 10 */ },
                { text: "비고", value: "remark", align: "center", /* width: 10 */ },
                { text: "일자", value: "createdAt", align: "center", /* width: 10 */ },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "이름", value: "member.name" },
                { text: "아이디", value: "member.username" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, points } = await api.console.points.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.points = points;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        async excel(){
            let { points } = await api.console.points.gets({ headers: { limit: 0 }, params: this.filter });

            let rows = [];
            points.forEach(point => {
                rows.push({
                    "회원 이름": point?.member?.name,
                    "회원 아이디": point?.member?.username,
                    "포인트 금액": point?.amount,
                    "비고": point?.remark,
                    "일자": this.$dayjs(point?.createdAt)?.format("YYYY-MM-DD HH:mm:ss")
                });
            });

            let workbook = new XLSX.utils.book_new();
            let worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "엑셀시트이름");
            XLSX.writeFile(workbook, "엑셀파일이름.xlsx");
        }
    }
}
</script>